import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { ConnectForm } from "@/components/ConnectForm";
import { Seo } from "@/components/Seo";

const IMAGES = {
  hero: "https://images.squarespace-cdn.com/content/v1/609884cf2896e65339ffb681/1621879651653-U1NXE3ZMYJBJN0VE8V1C/IMG_4838.jpg",
  work: "https://images.unsplash.com/photo-1620325867502-221cfb5faa5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMGNvbnN1bHRpbmclMjBzdHJhdGVneSUyMG5vdGVzfGVufDB8fHx8MTc5MzY0Nzk4Nnww&ixlib=rb-4.1.0&q=85",
  people: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxrZXlub3RlJTIwc3BlYWtlciUyMGVkaXRvcmlhbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MzY0Nzk4Nnww&ixlib=rb-4.1.0&q=85",
  stories: "https://images.unsplash.com/photo-1485579149621-3123dd979885?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxsaXRlcmFyeSUyMGpvdXJuYWwlMjBtaWNyb3Bob25lfGVufDB8fHx8MTc5MzY0Nzk4Nnww&ixlib=rb-4.1.0&q=85",
  talent1: "https://www.dnicholedavis.com/assets/about-portrait-kDmb5S-8.jpg",
  talent2: "https://images.squarespace-cdn.com/content/v1/6a2184e15ceea5553bc34d54/c7c27c5a-c0a1-4612-8675-be6ab6ab2085/IMG_6453.jpg",
  project1: "https://images.unsplash.com/photo-1579539760267-b2e78d9d735e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxzdGFnZSUyMHByb2R1Y3Rpb24lMjBlbnNlbWJsZSUyMGxpZ2h0c3xlbnwwfHx8MTc5MzY0Nzk4Nnww&ixlib=rb-4.1.0&q=85",
  project2: "https://images.unsplash.com/photo-1568219557405-376e23e4f7cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMGNvbnN1bHRpbmclMjBzdHJhdGVneSUyMG5vdGVzfGVufDB8fHx8MTc5MzY0Nzk4Nnww&ixlib=rb-4.1.0&q=85",
  project3: "https://images.unsplash.com/photo-1757085242641-d829ddde7191?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxjb21tdW5pdHklMjB3b3Jrc2hvcCUyMGdhbGxlcnl8ZW58MHx8fHwxNzkzNjQ3OTg2fDA&ixlib=rb-4.1.0&q=85",
  podcast: "https://images.unsplash.com/photo-1660631228116-b3643559f611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxwb2RjYXN0JTIwc3R1ZGlvJTIwbWljcm9waG9uZXxlbnwwfHx8MTc5MzY0Nzk4Nnww&ixlib=rb-4.1.0&q=85",
};

const PATHWAYS = [
  {
    num: "Pathway 01",
    title: "The Work",
    copy: "Coaching, consulting, business development, and strategic counsel for creators and cultural institutions scaling their voice.",
    img: IMAGES.work,
    caption: "Consulting & Platform Strategy",
    cta: "Explore Our Work →",
    to: "/our-work",
    testId: "pathway-work",
  },
  {
    num: "Pathway 02",
    title: "The People",
    copy: "Boutique talent representation for distinct speakers, performers, and survivor-centered artists booking keynote engagements.",
    img: IMAGES.people,
    caption: "Talent Roster & Management",
    cta: "View Talent →",
    to: "/our-people",
    testId: "pathway-people",
  },
  {
    num: "Pathway 03",
    title: "The Stories",
    copy: "Original artistic programming, editorial publications, podcasts, and community storytelling series that reshape culture.",
    img: IMAGES.stories,
    caption: "Programming & Media",
    cta: "Listen & Read →",
    to: "/stories-culture",
    testId: "pathway-stories",
  },
];

const TALENT = [
  {
    name: "D. Nichole Davis",
    role: "Speaker, Leader & Author",
    focus: "Leadership, professional development, and stroke survivorship. Delivering transformative keynotes on resilience, executive growth, and human-centered leadership.",
    img: IMAGES.talent1,
    caption: "D. Nichole Davis / Speaker, Leader & Author",
    cta: "Book D. Nichole Davis →",
    testId: "talent-davis",
  },
  {
    name: "Jenn Wilenta",
    role: "Dancer, Educator & Speaker",
    focus: "Trauma & healing. Honest conversations about what it means not only to survive trauma, but to rebuild a life after it.",
    img: IMAGES.talent2,
    caption: "Jenn Wilenta / Dancer, Educator & Speaker",
    cta: "Book Jenn Wilenta →",
    testId: "talent-wilenta",
  },
];

const PROJECTS = [
  {
    tag: "Anthology",
    title: "WRITE HOME: Letters to a Younger Me",
    copy: "A community anthology with Athenaeum Press at Coastal Carolina University — four free creative writing workshops and a published book of letters to our younger selves.",
    img: "https://images.squarespace-cdn.com/content/v1/609884cf2896e65339ffb681/3a3271e7-e24c-41d7-ae53-6a303268b12d/Facebook+Cover+-+Join+the+Write+Home+Community+Project.png",
    caption: "Anthology / Athenaeum Press",
    url: "https://theathenaeumpress.com/projects/write-home-letters-to-a-younger-me/",
  },
  {
    tag: "Memoir",
    title: "Welcome to the Sh*t Show",
    copy: "Shannon Ivey's memoir of colorectal cancer and the power of self-advocacy, published by University of South Carolina Press in 2026.",
    img: "https://images.squarespace-cdn.com/content/v1/672a48b558540252c5213760/279038f7-bbbc-4164-8381-1a3d4d62199f/Ivey-cover.jpg",
    caption: "Book / USC Press 2026",
    url: "https://shannon-ivey.com/bookspeaking",
  },
  {
    tag: "Community Initiative",
    title: "Poet of Witness",
    copy: "A Southern survivorship initiative using poetry and narrative practice to bring patients, caregivers, clinicians, and communities into shared witnessing.",
    img: "https://images.squarespace-cdn.com/content/v1/672a48b558540252c5213760/682e64cc-8e54-470c-a002-c5ef38c0d44a/Story+Slam+2017+%288+of+13%29.jpg",
    caption: "Survivorship & Storytelling",
    url: "https://shannon-ivey.com/",
  },
];

const BLOG_POSTS = [
  {
    date: "Dec 2025",
    cat: "Essays",
    title: "A Blessing for the Badasses",
    copy: "On the year transition...",
    url: "https://shannonivey.substack.com/p/a-blessing-for-the-bad-asses",
  },
  {
    date: "Dec 2025",
    cat: "Essays",
    title: "Confessions of a Recovering Vigilante Helper",
    copy: "When helping becomes a way to outrun discomfort—and what it costs us.",
    url: "https://shannonivey.substack.com/p/confessions-of-a-recovering-vigilante",
  },
  {
    date: "Aug 2025",
    cat: "Essays",
    title: "Where the Light Comes Out: A Deep Dive on Roxane Gay and Writing Trauma",
    copy: "“We are walking wounds, but I am not sure any of us know quite how to talk about it.”",
    url: "https://shannonivey.substack.com/p/where-the-light-comes-out-a-deep",
  },
];

const MARQUEE_ITEMS = [
  "Stories move people",
  "People move culture",
  "From the street to the statehouse",
  "From the page to the stage",
  "Creative development",
  "Talent management",
];

const figureFrame =
  "relative bg-[#f4f4f4] border border-[#e5e5e5] overflow-hidden";
const captionClass =
  "absolute bottom-4 left-4 text-[11px] font-mono uppercase tracking-[.12em] text-[#666666] bg-white/90 px-3 py-1.5 border border-[#e5e5e5]";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const YOUTUBE_PLAYLIST_URL = process.env.REACT_APP_YOUTUBE_PLAYLIST_URL;

const TEDX_VIDEO = {
  title: "What Cancer Taught Me About Care",
  url: "https://www.youtube.com/watch?v=SloEhSgZOQ4",
  img: "https://i.ytimg.com/vi_webp/SloEhSgZOQ4/maxresdefault.webp",
  excerpt: "Shannon Ivey's TEDxCongaree Vista talk on care, survivorship, and what a stage III colorectal cancer diagnosis taught her.",
};

const HomePage = () => {
  const [slamVideos, setSlamVideos] = useState([]);
  const [episodes, setEpisodes] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog?category=Theater%20%26%20Performance`).then((res) => {
      setSlamVideos(res.data.slice(0, 2));
    }).catch(() => {});
    axios.get(`${API}/podcast`).then((res) => {
      const sorted = [...res.data].sort(
        (a, b) => (b.episode_number || 0) - (a.episode_number || 0)
      );
      setEpisodes(sorted.slice(0, 3));
    }).catch(() => {});
  }, []);

  return (
    <>
      <Seo
        title="#whatshesaidproject — Stories Move People. People Move Culture."
        description="#whatshesaidproject is a mission-led creative and cultural organization working at the intersection of story, people, and culture — coaching, consulting, boutique talent management, and artistic programming."
        path="/"
      />
      {/* HERO */}
      <section id="home" className="bg-white text-[#121212] pt-12 pb-24 md:py-28 border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-wrap items-center justify-between gap-4 pb-8 border-b border-[#121212] text-xs font-mono uppercase tracking-[.14em] text-[#555555]">
            <span>From the street to the statehouse and from the page to the stage.</span>
          </div>

          <div className="py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8 min-w-0">
              <h1
                data-testid="hero-headline"
                className="font-disp text-[clamp(40px,5.5vw,88px)] leading-[0.95] tracking-[-0.03em] font-normal text-[#121212] text-balance"
              >
                <span className="ln">
                  <span>Stories move people.</span>
                </span>
                <span className="ln">
                  <span>People move culture.</span>
                </span>
              </h1>
            </div>
            <div className="lg:col-span-4 fade-in-1">
              <p className="text-[17px] leading-[1.6] text-[#444444] mb-6">
                We collaborate with mission-led writers, artists, speakers, entrepreneurs,
                advocates, and changemakers to shift how the world listens.
              </p>
              <div className="flex flex-wrap items-center gap-4">
                <Link
                  to="/connect"
                  data-testid="hero-cta-connect"
                  className="inline-flex items-center justify-center px-6 py-3.5 bg-[#121212] text-white text-xs font-mono uppercase tracking-[.14em] hover:bg-[#e02020] transition-colors rounded-none"
                >
                  Connect
                </Link>
                <a
                  href="#about"
                  data-testid="hero-cta-thesis"
                  className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020] transition-colors"
                >
                  Read Thesis →
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 pt-6">
            <div className="md:col-span-8 fade-in-2">
              <a
                href={YOUTUBE_PLAYLIST_URL || "#"}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-exhibition-link"
                className="block group"
              >
                <figure className={`${figureFrame} aspect-[16/9]`}>
                  <img
                    src={IMAGES.hero}
                    alt="A #whatshesaidproject storyteller on stage in front of the project's branded screen"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                <figcaption className={captionClass}>
                  #whatshesaidproject Story Slam →
                </figcaption>
              </figure>
              </a>
            </div>
            <div className="md:col-span-4 flex flex-col justify-between p-6 bg-[#fafafa] border border-[#e5e5e5] fade-in-3">
              <div>
                <span className="text-xs font-mono uppercase tracking-[.14em] text-[#e02020] block mb-2">
                  Our Focus
                </span>
                <h2 className="font-disp text-2xl leading-tight text-[#121212] mb-3">
                  Intersection of Story, Voice, and Strategy
                </h2>
                <p className="text-sm text-[#555555] leading-relaxed">
                  Coaching, talent management, artistic programming, and cultural consulting for
                  creators who shift paradigms.
                </p>
              </div>
              <div className="pt-6 border-t border-[#e5e5e5] flex justify-between items-center text-xs font-mono text-[#6b6b6b]">
                <span>Established Mission</span>
                <span className="text-[#121212]">Expanded Platform</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <div className="bg-[#121212] text-white py-4 overflow-hidden border-y border-[#121212]" aria-hidden="true">
        <div className="mq-track whitespace-nowrap text-xs font-mono uppercase tracking-[.22em]">
          {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
            <span key={i} className="mx-8">
              &bull; {item}
            </span>
          ))}
        </div>
      </div>

      {/* ABOUT */}
      <section id="about" className="bg-white text-[#121212] py-24 md:py-32 border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-4">
              <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-3">
                Who We Are
              </span>
              <h2 className="font-disp text-[clamp(32px,4vw,56px)] leading-[1.05] tracking-tight font-normal text-[#121212]">
                A creative &amp; cultural organization.
              </h2>
            </div>
            <div className="lg:col-span-8 min-w-0 space-y-6 text-[17px] leading-[1.65] text-[#333333]">
              <p>
                #whatshesaidproject works at the intersection of story, people, and culture. We
                collaborate with writers, artists, speakers, advocates, and changemakers to develop
                their work, strengthen their platforms, and create opportunities for meaningful
                connection and impact.
              </p>
              <p className="text-[#555555]">
                Our work encompasses coaching, consulting, business development, boutique talent
                management, artistic programming, podcasting, and community engagement. We are not
                a political organization or an advocacy campaign agency; we believe stories can
                change how people see themselves, one another, and the world.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-[#e5e5e5] font-mono text-xs uppercase tracking-[.14em]">
                <div>
                  <span className="text-[#121212] font-semibold block mb-1">Grassroots Roots</span>
                  <span className="text-[#666666] normal-case tracking-normal">
                    Grounded community storytelling practice.
                  </span>
                </div>
                <div>
                  <span className="text-[#121212] font-semibold block mb-1">Statehouse Reach</span>
                  <span className="text-[#666666] normal-case tracking-normal">
                    Institutional and cultural platform scale.
                  </span>
                </div>
                <div>
                  <span className="text-[#121212] font-semibold block mb-1">Boutique Roster</span>
                  <span className="text-[#666666] normal-case tracking-normal">
                    Deep, tailored creative management.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THREE PATHWAYS */}
      <section id="work" className="bg-[#fafafa] text-[#121212] py-24 md:py-32 border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 pb-6 border-b border-[#121212]">
            <div>
              <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-2">
                Three Pathways
              </span>
              <h2 className="font-disp text-[clamp(32px,4vw,56px)] leading-[1.05] tracking-tight font-normal text-[#121212]">
                How We Collaborate
              </h2>
            </div>
            <p className="text-xs font-mono uppercase tracking-[.14em] text-[#666666] mt-4 md:mt-0">
              Tailored routing for artists, partners, and presenters
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {PATHWAYS.map((p) => (
              <article
                key={p.num}
                data-testid={`pathway-card-${p.testId}`}
                className="bg-white border border-[#e5e5e5] hover:border-[#121212] transition-colors p-8 flex flex-col justify-between"
              >
                <div>
                  <span className="text-xs font-mono uppercase tracking-[.14em] text-[#e02020] block mb-4">
                    {p.num}
                  </span>
                  <h3 className="font-disp text-3xl text-[#121212] mb-3">{p.title}</h3>
                  <p className="text-sm text-[#555555] leading-relaxed mb-6">{p.copy}</p>
                </div>
                <figure className={`${figureFrame} aspect-[4/3] mb-6`}>
                  <img
                    src={p.img}
                    alt={p.caption}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <figcaption className={captionClass}>{p.caption}</figcaption>
                </figure>
                <Link
                  to={p.to}
                  data-testid={`${p.testId}-link`}
                  className="inline-flex items-center text-xs font-mono uppercase tracking-[.14em] text-[#121212] font-semibold hover:text-[#e02020] transition-colors"
                >
                  {p.cta}
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURED TALENT */}
      <section id="people" className="bg-white text-[#121212] py-24 md:py-32 border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-2xl mb-16">
            <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-2">
              Boutique Roster
            </span>
            <h2 className="font-disp text-[clamp(32px,4vw,56px)] leading-[1.05] tracking-tight font-normal text-[#121212] mb-4">
              Featured Talent
            </h2>
            <p className="text-[17px] text-[#555555] leading-relaxed">
              Collaborators and managed voices driving crucial conversations across national
              stages, academic institutions, and cultural forums.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {TALENT.map((t) => (
              <article
                key={t.name}
                data-testid={`talent-card-${t.testId}`}
                className="border border-[#e5e5e5] p-8 flex flex-col justify-between bg-[#fafafa]"
              >
                <div>
                  <figure className={`${figureFrame} aspect-[4/3] mb-6`}>
                    <img
                      src={t.img}
                      alt={t.caption}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <figcaption className={captionClass}>{t.caption}</figcaption>
                  </figure>
                  <div className="flex items-baseline justify-between border-b border-[#e5e5e5] pb-3 mb-4">
                    <h3 className="font-disp text-2xl text-[#121212]">{t.name}</h3>
                    <span className="text-xs font-mono uppercase tracking-[.14em] text-[#e02020]">
                      {t.role}
                    </span>
                  </div>
                  <p className="text-sm text-[#444444] leading-relaxed mb-6">{t.focus}</p>
                </div>
                <Link
                  to="/connect"
                  data-testid={`${t.testId}-link`}
                  className="inline-flex items-center text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020] transition-colors"
                >
                  {t.cta}
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* SELECTED CREATIVE PROJECTS */}
      <section id="stories-move" className="bg-[#fafafa] text-[#121212] py-24 md:py-32 border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 pb-6 border-b border-[#121212]">
            <div>
              <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-2">
                Portfolio
              </span>
              <h2 className="font-disp text-[clamp(32px,4vw,56px)] leading-[1.05] tracking-tight font-normal text-[#121212]">
                Selected Creative Projects
              </h2>
            </div>
            <p className="text-xs font-mono uppercase tracking-[.14em] text-[#666666] mt-4 md:mt-0">
              Initiatives spanning stage, digital, and print
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {PROJECTS.map((p) => (
              <a
                key={p.title}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`project-card-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="block group bg-white border border-[#e5e5e5] hover:border-[#121212] transition-colors p-6"
              >
                <figure className={`${figureFrame} aspect-[16/10] mb-4`}>
                  <img
                    src={p.img}
                    alt={p.caption}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <figcaption className={captionClass}>{p.caption}</figcaption>
                </figure>
                <span className="text-xs font-mono uppercase tracking-[.14em] text-[#e02020] block mb-1">
                  {p.tag}
                </span>
                <h3 className="font-disp text-xl text-[#121212] group-hover:text-[#e02020] transition-colors mb-2">{p.title}</h3>
                <p className="text-xs text-[#555555] leading-relaxed">{p.copy}</p>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* STORY SLAM VIDEOS */}
      {slamVideos.length > 0 && (
        <section id="watch" className="bg-white text-[#121212] py-24 md:py-32 border-b border-[#e5e5e5]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 pb-6 border-b border-[#121212]">
              <div>
                <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-2">
                  Watch
                </span>
                <h2 className="font-disp text-[clamp(32px,4vw,56px)] leading-[1.05] tracking-tight font-normal text-[#121212]">
                  Story Slams &amp; Performance
                </h2>
              </div>
              <a
                href={YOUTUBE_PLAYLIST_URL || "#"}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="watch-youtube-link"
                className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020] transition-colors mt-4 md:mt-0"
              >
                Watch on YouTube →
              </a>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <a
                href={TEDX_VIDEO.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="watch-tedx-link"
                className="group border border-[#121212] bg-white"
              >
                <figure className="relative aspect-video bg-[#f4f4f4] border-b border-[#e5e5e5] overflow-hidden">
                  <img
                    src={TEDX_VIDEO.img}
                    alt={TEDX_VIDEO.title}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </figure>
                <div className="p-6">
                  <span className="text-xs font-mono uppercase tracking-[.14em] text-[#e02020] block mb-2">
                    TEDx
                  </span>
                  <h3 className="font-disp text-xl text-[#121212] group-hover:text-[#e02020] transition-colors mb-2">
                    {TEDX_VIDEO.title}
                  </h3>
                  <p className="text-sm text-[#555555] leading-relaxed">{TEDX_VIDEO.excerpt}</p>
                </div>
              </a>
              {slamVideos.map((video) => (
                <a
                  key={video.id}
                  href={video.featured_image?.includes('ytimg') ? video.content?.match(/https:\/\/www\.youtube\.com\/watch\?v=[\w-]+/)?.[0] || '#' : '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`slam-video-${video.slug}`}
                  className="group border border-[#e5e5e5] hover:border-[#121212] transition-colors bg-white"
                >
                  {video.featured_image && (
                    <figure className="relative aspect-video bg-[#f4f4f4] border-b border-[#e5e5e5] overflow-hidden">
                      <img
                        src={video.featured_image}
                        alt={video.title}
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                    </figure>
                  )}
                  <div className="p-6">
                    <h3 className="font-disp text-xl text-[#121212] group-hover:text-[#e02020] transition-colors mb-2">
                      {video.title}
                    </h3>
                    <p className="text-sm text-[#555555] leading-relaxed">{video.excerpt}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* DISPATCHES & PODCAST */}
      <section id="stories" className="bg-white text-[#121212] py-24 md:py-32 border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6">
          {/* Podcast */}
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 pb-6 border-b border-[#121212]">
            <div>
              <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-2">
                Podcast Series
              </span>
              <h2 className="font-disp text-[clamp(32px,4vw,56px)] leading-[1.05] tracking-tight font-normal text-[#121212]">
                Latest Episodes
              </h2>
            </div>
            <a
              href="https://podcasts.apple.com/us/podcast/whatshesaidproject/id1523686350"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="podcast-listen-link"
              className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020] transition-colors mt-4 md:mt-0"
            >
              Listen on Apple Podcasts →
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
            {episodes.map((ep) => (
              <a
                key={ep.id}
                href={ep.platform_links?.[0]?.url || "/podcast"}
                target={ep.platform_links?.[0]?.url ? "_blank" : undefined}
                rel={ep.platform_links?.[0]?.url ? "noopener noreferrer" : undefined}
                data-testid={`podcast-card-${ep.id}`}
                className="group border border-[#e5e5e5] hover:border-[#121212] transition-colors bg-white p-6 flex flex-col justify-between"
              >
                <div>
                  <span className="text-xs font-mono uppercase tracking-[.14em] text-[#666666] block mb-3">
                    {ep.episode_number ? `Episode ${ep.episode_number}` : "Episode"}
                  </span>
                  <h3 className="font-disp text-xl text-[#121212] group-hover:text-[#e02020] transition-colors mb-3">
                    {ep.title}
                  </h3>
                  {ep.guest && (
                    <p className="text-xs font-mono uppercase tracking-[.14em] text-[#e02020] mb-3">
                      With {ep.guest}
                    </p>
                  )}
                  <p className="text-sm text-[#555555] leading-relaxed line-clamp-4">
                    {ep.description}
                  </p>
                </div>
                <span className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] mt-6 inline-block">
                  Listen →
                </span>
              </a>
            ))}
          </div>

          {/* Latest Blog Posts */}
          <div>
            <div className="flex items-center justify-between pb-4 border-b border-[#121212] mb-8 text-xs font-mono uppercase tracking-[.14em]">
              <span className="text-[#121212] font-semibold">Latest Journal Entries</span>
              <span className="text-[#e02020]">Editorial Writing</span>
            </div>

            <div className="space-y-8">
              {BLOG_POSTS.map((post) => (
                <a
                  key={post.title}
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`journal-entry-${post.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="block border-b border-[#e5e5e5] pb-8 last:border-b-0 last:pb-0 group"
                >
                  <div className="flex items-center gap-3 text-xs font-mono text-[#6b6b6b] mb-2">
                    <span>{post.date}</span>
                    <span>&bull;</span>
                    <span className="text-[#e02020]">{post.cat}</span>
                  </div>
                  <h3 className="font-disp text-2xl text-[#121212] group-hover:text-[#e02020] transition-colors mb-2">
                    {post.title}
                  </h3>
                  <p className="text-sm text-[#555555] leading-relaxed">{post.copy}</p>
                </a>
              ))}
            </div>

            <div className="pt-8">
              <a
                href="https://shannonivey.substack.com/archive"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="blog-archive-link"
                className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020] transition-colors"
              >
                Browse Entire Archive →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* INVITATION TO COLLABORATE */}
      <section id="connect" className="bg-[#121212] text-white py-24 md:py-32">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-3">
                Invitation to Collaborate
              </span>
              <h2 className="font-disp text-[clamp(32px,4vw,56px)] leading-[1.05] tracking-tight font-normal text-white mb-6">
                Let us move culture together.
              </h2>
              <p className="text-[17px] text-[#aaaaaa] leading-relaxed mb-8">
                Whether you are an artist seeking coaching and representation, or an organization
                booking keynote talent, initiate an inquiry below.
              </p>
              <ul className="space-y-4 text-xs font-mono uppercase tracking-[.14em] text-[#6b6b6b]">
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-[#e02020]" aria-hidden="true" />
                  <span>Keynote &amp; Talent Bookings</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-[#e02020]" aria-hidden="true" />
                  <span>Boutique Consulting &amp; Coaching</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-[#e02020]" aria-hidden="true" />
                  <span>Creative Partnerships &amp; Grants</span>
                </li>
              </ul>
            </div>

            <div className="lg:col-span-7 bg-[#1c1c1c] border border-[#2e2e2e] p-8 md:p-10">
              <ConnectForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
